var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn btn-secondary px-5 py-3 fw-semibold font-weight-bold z-2 secondary-button",on:{"click":_vm.callBack}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }